import { i18n } from '@/commons/utils';

export const templateSuggestion = suggestion =>
  `<li>${suggestion.description}</li>`;

export const templateAutocomplete = `
  <div class="dkt-form dkt-form--solo-input store-selection__search-form">
    <input class="js-input" type="text"
        placeholder="${i18n('storeselection.inputPlaceholder')}">
    <button type="submit" class="dkt-form__submit dkt-form__submit--backward">
      <span class="dkti-search"></span>
    </button>
    <button class="store-selection__flush-search">
      <span class="dkti-cross js-close"></span>
    </button>
    <span class="store-selection__load-indicator dkti-hourglass"></span>
  </div>
  <button class="js-locate-me dkti dkti-geolocalization store-selection__location-invite"></button>
  <ul class="js-suggestions store-selection__suggestion-list"></ul>
`;



// WEBPACK FOOTER //
// ./src/commons/component/autocomplete/ac-templates.js